module.exports = __webpack_public_path__ + "img/Country3-2.9efb43de.png";